module.exports = __webpack_public_path__ + "media/images/icon/user-b05c5de8939abecaa85fa66c6b832cbf.svg";